export  function renderTotal(totalPedido) {
    return `
        <h1><strong>TOTAL</strong><strong> <span class='preco'>R$ ${totalPedido}</span> </strong> </h1>
                   
    `
}